import { Box, Skeleton } from '@mui/material';

const ContactDetailsSkeleton = () => {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: 400,
                borderRadius: 1,
                overflow: 'hidden',
            }}
        >
            {/* Profile section with avatar and name */}
            <Box
                sx={{
                    bgcolor: '#f5f5f5',
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Skeleton
                    variant="circular"
                    width={120}
                    height={120}
                    sx={{ mb: 2 }}
                />
                <Skeleton variant="text" width={140} height={48} />
            </Box>
            {/* Contact info section */}
            <Box sx={{ p: 3 }}>
                <Skeleton
                    variant="text"
                    width={140}
                    height={32}
                    sx={{ mb: 2 }}
                />

                {/* Email skeleton */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Skeleton
                        variant="circular"
                        width={24}
                        height={24}
                        sx={{ mr: 2 }}
                    />
                    <Skeleton variant="text" width="80%" height={24} />
                </Box>

                {/* Phone numbers skeleton */}
                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <Skeleton
                        variant="circular"
                        width={24}
                        height={24}
                        sx={{ mr: 2 }}
                    />
                    <Box sx={{ width: '80%' }}>
                        <Skeleton variant="text" width="100%" height={24} />
                        <Skeleton variant="text" width="100%" height={24} />
                    </Box>
                </Box>

                {/* Tags/Labels skeleton */}
                <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                    <Skeleton variant="rounded" width={120} height={32} />
                    <Skeleton variant="rounded" width={120} height={32} />
                </Box>

                {/* Add Label button skeleton */}
                <Skeleton
                    variant="rounded"
                    width={100}
                    height={36}
                    sx={{ mt: 2, borderRadius: 1 }}
                />
            </Box>
        </Box>
    );
};

export default ContactDetailsSkeleton;
